'use strict';
var app = require('angular').module('directive.toggle', []);

app.directive('toggle', [require('./toggleDirective')]);
